<template>
    <div class="modal-overlay" @click.self="emitClose">
        <div class="modal">
            <div class="modal-header">
                <h1 class="modal-title">Podsumowanie wybranych opcji</h1>
                <button class="close-button" @click="emitClose">
                    <font-awesome-icon icon="xmark" size="xs" />
                </button>
            </div>

            <div class="modal-content">
                <div class="selected-model" v-if="trailerStore.selectedTrailer">
                    <h2 class="model-title">Wybrany model:</h2>
                    <div class="summary-item">
                        <img v-if="trailerStore.selectedTrailer.image_url" :src="trailerStore.selectedTrailer.image_url"
                            :alt="trailerStore.selectedTrailer.name" class="item-image" />
                        <div class="item-details">
                            <p class="item-name">{{ trailerStore.selectedTrailer.name }}</p>
                            <p class="item-price">{{ format(trailerBasePrice) }}</p>
                        </div>
                    </div>
                </div>

                <div v-if="selectedAddons.length > 0">
                    <h2 class="option-title">Akcesoria</h2>

                    <div v-for="(addons, groupName) in groupedSelectedAddons" :key="groupName" class="option-group">
                        <h3 class="group-title">{{ groupName }}</h3>

                        <div v-for="addon in addons" :key="addon.id" class="summary-item">
                            <img v-if="addon.image_url" :src="addon.image_url" :alt="addon.desc" class="item-image" />
                            <div class="item-details">
                                <p class="item-name">{{ addon.desc }}</p>
                                <p class="item-price">{{ format(addon.price) }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else class="no-addons">
                    <p>Nie wybrano żadnych dodatków.</p>
                </div>

                <div class="price-summary">
                    <h1 class="summary-title">Miejsce realizacji zamówienia:</h1>
                    <p>Sławacinek Nowy 26</p>
                </div>
                <div class="price-summary">
                    <h1 class="summary-title">Miejsce odbioru zamówienia:</h1>
                    <p>Sławacinek Nowy 26</p>
                </div>
                <div class="price-summary" v-if="trailerStore.selectedTrailer">
                    <h2 class="summary-title">Podsumowanie cen:</h2>

                    <div class="summary-row">
                        <h3 class="price-label">Cena bazowa:</h3>
                        <h3 class="price-value">{{ format(trailerBasePrice) }}</h3>
                    </div>
                    <div class="summary-row">
                        <h3 class="price-label">Wybrane akcesoria ({{ selectedAddons.length }}):</h3>
                        <h3 class="price-value">{{ format(totalAddonPrice) }}</h3>
                    </div>
                    <div class="summary-row total-row">
                        <h1 class="total-label">Łączna cena:</h1>
                        <h1 class="total-value">{{ format(totalPrice) }}</h1>
                    </div>
                </div>
                <button class="save-button" @click="$emit('open-save-config')">Zamów konfigurację</button>
            </div>
        </div>
    </div>
</template>

<script>
import { useTrailerStore } from '@/stores/trailerStore';

export default {
    name: 'SummaryComponent',
    emits: ['close'],
    computed: {
        trailerStore() {
            return useTrailerStore();
        },
        selectedAddons() {
            return this.trailerStore.selectedTrailerAddons;
        },
        totalAddonPrice() {
            return this.trailerStore.selectedTrailerAddonsPriceSum;
        },
        trailerBasePrice() {
            return this.trailerStore.selectedTrailer?.price || 0;
        },
        totalPrice() {
            return this.trailerBasePrice + this.totalAddonPrice;
        },
        groupedSelectedAddons() {
            const grouped = {};
            for (const addon of this.selectedAddons) {
                const group = addon.group || 'Inne';
                if (!grouped[group]) grouped[group] = [];
                grouped[group].push(addon);
            }
            return grouped;
        }
    },
    methods: {
        emitClose() {
            this.$emit('close');
        },
        format(price) {
            return this.trailerStore.formatPrice(price) + ' zł';
        }
    }
};
</script>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    padding: 20px;
}

.modal {
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    background-color: $color-background;
    border-radius: 12px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.modal-header {
    padding: 20px;
    background-color: $color-primary;
    color: $color-white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
}

.close-button {
    background: none;
    border: none;
    color: $color-white;
    font-size: 2rem;
    cursor: pointer;
    padding: 0 10px;
    line-height: 1;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }
}

.modal-content {
    padding: 20px;
    overflow-y: auto;
    flex-grow: 1;
}

.selected-model {
    margin-bottom: 25px;
}

.model-title,
.option-title {
    color: $color-primary;
    font-size: 1.1rem;
    margin-bottom: 12px;
    padding-bottom: 6px;
    border-bottom: 1px solid $color-grey;
}

.option-group {
    margin-bottom: 25px;
}

.group-title {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 8px;
    color: $color-text;
    border-left: 3px solid $color-primary;
    padding-left: 10px;
}

.summary-item {
    display: flex;
    align-items: center;
    padding: 12px;
    background-color: $color-white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    margin-bottom: 10px;
}

.item-image {
    width: 60px;
    height: 60px;
    object-fit: contain;
    border-radius: 4px;
    margin-right: 15px;
}

.item-details {
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.item-name {
    color: $color-text;
    font-weight: 500;
    margin: 0;
}

.item-price {
    color: $color-primary;
    font-weight: 600;
    margin: 0;
    min-width: 80px;
    text-align: right;
}

.price-summary {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid $color-grey;
}

.summary-title {
    color: $color-primary;
    font-size: 1.2rem;
    margin-bottom: 20px;
    text-align: left;
}

.summary-row {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid $color-grey-light;

    &.total-row {
        border-top: 2px solid $color-primary-light;
        border-bottom: none;
        margin-top: 15px;
        padding-top: 15px;
    }
}

.price-label {
    color: $color-text-light;
    font-weight: 500;
    margin: 0;
}

.price-value {
    color: $color-text;
    font-weight: 600;
    margin: 0;
}

.total-label {
    color: $color-primary-accent;
    font-size: 1.3rem;
    margin: 0;
}

.total-value {
    color: $color-primary-accent;
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0;
}

.no-addons {
    text-align: center;
    color: $color-text-light;
    font-size: 1rem;
    font-style: italic;
}

.save-button {
    background-color: $color-primary;
    color: $color-white;
    width: 100%;
    padding: 12px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
        background-color: $color-primary-dark;
    }
}

@media screen and (max-width: 768px) {
    .modal {
        max-height: 85vh;
    }

    .modal-header {
        padding: 15px;
    }

    .modal-title {
        font-size: 1.2rem;
    }

    .item-image {
        width: 50px;
        height: 50px;
    }

    .item-name,
    .item-price {
        font-size: 0.9rem;
    }

    .total-label,
    .total-value {
        font-size: 1.1rem;
    }
}
</style>